module.exports = __webpack_public_path__ + "static/img/a2b3ff2f9978a9e69e2e81f43d9ad4ca.44ed2cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a2b3ff2f9978a9e69e2e81f43d9ad4ca.jpg
// module id = R/Sl
// module chunks = 4